export enum ProfileTab {

    ACCOUNT = "ACCOUNT",
    CHANGE_PASSWORD = "CHANGE_PASSWORD",
    SUBSCRIPTION = "SUBSCRIPTION"
}